import * as React from 'react';

import { Link } from 'components/common/router';
import { Alert } from 'components/bootstrap';
import Routes from 'routing/Routes';
import { isPermitted } from 'util/PermissionsMixin';
import type User from 'logic/users/User';

type Props = {
  currentUser: User;
  expiredSince: string;
};

/**
 * Renders an alert for expired licenses.
 */
const LicenseExpirationNotification = ({ expiredSince, currentUser }: Props) => (
  <Alert bsStyle="danger" className="has-bm" title="Graylog License Expired">
    <p>
      Your Graylog license <strong>expired {expiredSince} ago</strong> and the corresponding features have been
      disabled.{' '}
      {isPermitted(currentUser.permissions, 'licenses:create') ? (
        <span>
          Go to the <Link to={Routes.pluginRoute('SYSTEM_LICENSES')}>Licenses page</Link> for more information or
          contact your Graylog account manager.
        </span>
      ) : (
        <span>Contact your Graylog account manager for more information.</span>
      )}
    </p>
  </Alert>
);

export default LicenseExpirationNotification;
